<template>
  <div id="management-dyuser" class="table-section">
    <div class="query-section">
      <el-card class="box-card" shadow="never">
        <el-form :inline="true" :model="searchParams" class="form-inline" >
          <el-form-item label="用户名">
            <el-input v-model.trim="searchParams.agentName" placeholder="用户名" />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model.trim="searchParams.mobile" placeholder="手机号" />
          </el-form-item>
          <el-form-item label="角色">
            <el-select v-model="searchParams.roleId" placeholder="请选择">
              <el-option v-for="(item, index) in userRoleList" :key="index" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="度言员工编号">
            <el-input v-model.trim="searchParams.dyAccountId" placeholder="度言员工编号" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="" @click="clear">清空</el-button>
          </el-form-item>
          <el-button style="float: right;"  type="primary" @click="newUser">新增</el-button>
        </el-form>
      </el-card>
    </div>

    <div class="table-section">
      <el-table :data="manageUserList" :header-row-style="headerRowStyle" border highlight-current-row
        max-height="550px" style="width: 100%">
        <!-- <el-table-column prop="id" label="用户id" width="80px">
          <template slot-scope="scope">
            <router-link :to="{ name: 'manage-user-info', params: { uid: scope.row.id } }">{{ scope.row.id
              }}</router-link>
          </template>
        </el-table-column> -->
        <el-table-column prop="name" label="用户姓名" />
        <el-table-column prop="mobile" label="手机号" />
        <el-table-column label="角色为">

          <template slot-scope="scope">
            <span>{{ roleFilter(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dyAccountId" label="度言员工编号" />
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button @click="delDyAccountId(scope.row)" type="danger" icon="el-icon-delete" circle></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-section">
      <el-pagination :page-size="pageSize" :page-sizes="[5, 10, 15, 20]" :total="manageUserListTotalCount"
        layout="total, sizes, prev, pager, next" @current-change="changePage" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as manageApi from '../../api/manage.js'
import { getDictionaryList } from "@/api/manage";

export default {
  name: 'management-dyuser-list',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      searchParams: {
        type: 1
      },
      pageSize: 10,
      page: 1,
      bundleAddUser: false,
      fileList: [],
      path: process.env.BASE_API,
      userRoleList: []
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'manageUserList',
      'manageUserListTotalCount'
    ]),
    type() {
      return this.$route.query.type
    }
  },
  watch: {
    type: function(val, oldVal) {
      this.clear()
      this.loadUsers()
    }
  },
  async created() {
    // 用户角色
    const fdRoleRes = await getDictionaryList("fd_role");
    fdRoleRes.data.map((item) => {
      this.userRoleList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    this.path = process.env.BASE_API + manageApi.updatedLink
    this.loadUsers()
  },
  methods: {
    roleFilter(row) {
      for(let i=0;this.userRoleList && i<this.userRoleList.length;i++) {
        let item = this.userRoleList[i]
        if(item.value == row.role) {
          return item.label
        }
      }
      return ''
    },
    delDyAccountId(row) {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        manageApi.updateUserDyAccountId({type:2,id:row.id}).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功！'
          })
          this.loadUsers()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    ...mapActions([
      'fetchManageUserList'
    ]),
    loadUsers() {
      this.searchParams.userId = this.currentUser.id
      this.fetchManageUserList({ searchParams: this.searchParams, current: this.page, size: this.pageSize, queueType: this.type })
    },
    changePage(currentPage) {
      this.page = currentPage
      this.loadUsers()
    },
    search() {
      this.page = 1
      this.loadUsers()
    },
    clear() {
      this.searchParams = {
        type: 1
      }
    },
    newUser() {
      this.$router.push({ name: 'manage-dyuser-info' })
    },
    submitUpload() {
      this.$refs.upload.submit()
      console.log(this.$refs.upload.file)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleSuccess(response) {
      console.log(response)
      if (response.data === 'success') {
        this.$notify({
          title: '上传成功！',
          type: 'success',
          duration: 5000
        })
      } else {
        this.$notify.error({
          title: '出错了！',
          message: response.msg,
          type: 'error',
          duration: 5000
        })
      }
    }
  }
}
</script>
